<template>
  <section class="custom-manage">
    <h5>Configuration</h5>
    <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    <div class="row p-3" v-if="currentTab === 'Applications'">
      <applications ref="applications" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Protocols'">
      <assessments ref="assessments" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Help Videos'">
      <helpvideos ref="helpvideos" />
    </div>
    <div class="row p-3" v-if="currentTab === 'BI Templates'">
      <div class="col">
        <batch-intel-templates ref="batchIntelTemplates" />
      </div>
    </div>
    <div class="row p-3" v-if="currentTab === 'Views'">
      <div class="col"></div>
      <div class="col-4">
        <custom-views ref="views" />
      </div>
      <div class="col"></div>
    </div>
  </section>
</template>
<script>
import ZTabs from '@/Components/ZElements/Tabs'
import CustomViews from './custom-views'
import Applications from './application-listing'
import Assessments from './assessment-listing'
import Helpvideos from './helpvideo-listing'
import BatchIntelTemplates from './batch-intel-templates'
export default {
  name: 'configuration',
  components: {
    ZTabs,
    CustomViews,
    Applications,
    Assessments,
    Helpvideos,
    BatchIntelTemplates,
  },
  data() {
    return {
      currentTab: 'Applications',
      tabs: [
        'Applications',
        'Protocols',
        'Help Videos',
        'BI Templates',
        'Views',
      ],
    }
  },
  methods: {
    showTab(value) {
      this.currentTab = value
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
